export default __webpack_public_path__ + "static/media/miguel-lopes-21.836da50e.jpg";